import { useState, useCallback } from 'react';
import {
  fetchProtocoloSession, fetchProtocoloReceptoras, fetchProtocoloAplicacoes,
  saveProtocoloSession, montarPayloadProtocolo, sessaoParaTela,
} from '../data/protocolo';
import { getPending } from '../data/local/pending';

/**
 * Carrega e grava a etapa de PROTOCOLO.
 *
 * Mesmo desenho de `useTESession`: o que está na fila vence o servidor na
 * leitura, a gravação vai num RPC só, e o blob da tela viaja junto para a
 * fila poder devolvê-lo intacto depois.
 */
export const useProtocoloSession = (laboratoryId) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadProtocoloData = useCallback(async (serviceId) => {
    if (!serviceId || !laboratoryId) return null;
    setLoading(true);
    setError(null);
    try {
      // O lançado offline é mais novo que o do servidor, então vem por cima.
      const pendente = await getPending('protocolo', serviceId);
      if (pendente) return pendente;

      const sessao = await fetchProtocoloSession(serviceId);
      if (!sessao) return null;

      const [receptoras, aplicacoes] = await Promise.all([
        fetchProtocoloReceptoras(sessao.id),
        fetchProtocoloAplicacoes(sessao.id),
      ]);
      return sessaoParaTela(sessao, receptoras, aplicacoes);
    } catch (err) {
      console.error('useProtocoloSession.loadProtocoloData:', err);
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  }, [laboratoryId]);

  const saveProtocoloData = useCallback(async (serviceId, dados) => {
    if (!serviceId || !laboratoryId || !dados) return null;
    setLoading(true);
    setError(null);
    try {
      const params = montarPayloadProtocolo(serviceId, laboratoryId, dados);
      return await saveProtocoloSession(params, dados);
    } catch (err) {
      console.error('useProtocoloSession.saveProtocoloData:', err);
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  }, [laboratoryId]);

  return { loading, error, loadProtocoloData, saveProtocoloData };
};
